module.exports = __webpack_public_path__ + "static/media/Michelin_C_S_WhiteBG_RGB_0621-01.7188f348.svg";